"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.run_boarded = void 0;
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_1 = require("@main/common");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var voyageMessageCrewCreate_1 = require("@voyage/multi/voyageMessageCrewCreate");
var voyageMessageCrewCreate_sidecar_1 = require("@voyage/multi/voyageMessageCrewCreate-sidecar");
var voyageTilemap_sidecar_1 = require("../tilemap/voyageTilemap-sidecar");
function run_boarded(min, max) {
    var num = rando_sidecar_1.rando.i(min, max);
    for (var i = 0; i < num; i++) {
        setTimeout(function () {
            var fl = voyageTilemap_sidecar_1.voyageTilemap.getRandomFloor();
            voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
                crewId: common_1.createId(),
                i: fl.i,
                j: fl.j,
                team: 1,
                type: diveCrew_1.EVoyageCrewType.Enemy,
                heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                enemyType: '',
                method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Teleport,
                energy: 0,
                hitpoints: 100,
            });
        }, 1000 * i);
    }
}
exports.run_boarded = run_boarded;
